export default __webpack_public_path__ + "static/media/addIcon.74116bb1.svg";